import React from 'react';
export const FireIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-518">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" data-id="element-519" />
  </svg>;
export const ShieldIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-520">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-521" />
  </svg>;
export const ClockIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-522">
    <circle cx="12" cy="12" r="10" data-id="element-523" />
    <polyline points="12 6 12 12 16 14" data-id="element-524" />
  </svg>;
export const DollarIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-525">
    <line x1="12" y1="1" x2="12" y2="23" data-id="element-526" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-527" />
  </svg>;
export const TruckIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-528">
    <rect x="1" y="3" width="15" height="13" data-id="element-529" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" data-id="element-530" />
    <circle cx="5.5" cy="18.5" r="2.5" data-id="element-531" />
    <circle cx="18.5" cy="18.5" r="2.5" data-id="element-532" />
  </svg>;
export const UsersIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-533">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-534" />
    <circle cx="9" cy="7" r="4" data-id="element-535" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-536" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-537" />
  </svg>;
export const BoxIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-538">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" data-id="element-539" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" data-id="element-540" />
    <line x1="12" y1="22.08" x2="12" y2="12" data-id="element-541" />
  </svg>;
export const PhoneIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-542">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-543" />
  </svg>;
export const MapPinIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-544">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-545" />
    <circle cx="12" cy="10" r="3" data-id="element-546" />
  </svg>;
export const CheckIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-547">
    <polyline points="20 6 9 17 4 12" data-id="element-548" />
  </svg>;
export const ChevronDownIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-549">
    <polyline points="6 9 12 15 18 9" data-id="element-550" />
  </svg>;
export const StairsIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-551">
    <path d="M3 21h4v-4h4v-4h4v-4h4V5" data-id="element-552" />
  </svg>;
export const StarIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-553">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-554" />
  </svg>;
export const CalendarIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-555">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-556" />
    <line x1="16" y1="2" x2="16" y2="6" data-id="element-557" />
    <line x1="8" y1="2" x2="8" y2="6" data-id="element-558" />
    <line x1="3" y1="10" x2="21" y2="10" data-id="element-559" />
  </svg>;
export const WrenchIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-560">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" data-id="element-561" />
  </svg>;
export const FuelIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-562">
    <path d="M3 22V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v17" data-id="element-563" />
    <path d="M15 10h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2v0a1 1 0 0 0 1-1V8l-3-3" data-id="element-564" />
    <path d="M3 22h12" data-id="element-565" />
    <path d="M7 8h4" data-id="element-566" />
  </svg>;